import { handleErrors } from "../util/api-utils";

async function fetchDetailedDataExportBlob(endpoint, request) {
    const response = await fetch(endpoint, {
        method: "post",
        headers: {
            Accept: "text/csv",
            "Content-Type": "application/json",
        },
        body: JSON.stringify(request),
    });

    if (!response.ok) {
        await handleErrors(response);
    }

    return response.blob();
}

export function downloadBlob(blob, fileName) {
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    link.click();
    URL.revokeObjectURL(url);
}

export async function exportDetailedDataDownload(request) {
    const blob = await fetchDetailedDataExportBlob("api/Reports/RequestDetailedDataExport", request);
    const exportDate = new Date().toISOString().slice(0, 10);
    downloadBlob(blob, `agency-scorecard-${exportDate}.csv`);
}

export async function exportDetailedDataInternalDownload(request) {
    const blob = await fetchDetailedDataExportBlob("api/Reports/RequestDetailedDataExportInternal", request);
    const exportDate = new Date().toISOString().slice(0, 10);
    downloadBlob(blob, `agency-scorecard-${exportDate}.csv`);
}

export function getDetailedData(request, successCallback) {
    fetch("api/Reports/RequestDetailedData", {
        method: "post",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify(request)
    })
        .then(handleErrors)
        .then(successCallback)
        .catch(console.error);
};

export function getOverviewData(request, successCallback) {
    fetch("api/Reports/RequestOverviewData", {
        method: "post",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify(request)
    })
        .then(handleErrors)
        .then(successCallback)
        .catch(console.error);
};

export function getSweepsData(request, successCallback) {
    fetch("api/Reports/RequestSweepsData", {
        method: "post",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify(request)
    })
        .then(handleErrors)
        .then(successCallback)
        .catch(console.error);
}

export function getFilterOptions(successCallback, errorCallback) {
    fetch("api/Reports/RequestFilterOptions", {
        method: "get",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
    })
        .then(handleErrors)
        .then(successCallback)
        .catch(errorCallback);
}

export function getFilterOptionsInternal(substituteAgentId, successCallback, errorCallback) {
    fetch("api/Reports/RequestFilterOptionsInternal?substituteAgentId=" + substituteAgentId, {
        method: "get",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        }
    })
        .then(handleErrors)
        .then(successCallback)
        .catch(errorCallback);
}

export function getDetailedDataInternal(request, successCallback) {
    fetch("api/Reports/RequestDetailedDataInternal", {
        method: "post",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify(request)
    })
        .then(handleErrors)
        .then(successCallback)
        .catch(console.error);
};

export function getOverviewDataInternal(request, successCallback) {
    fetch("api/Reports/RequestOverviewDataInternal", {
        method: "post",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify(request)
    })
        .then(handleErrors)
        .then(successCallback)
        .catch(console.error);
};

export function getSweepsDataInternal(request, successCallback) {
    fetch("api/Reports/RequestSweepsDataInternal", {
        method: "post",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify(request)
    })
        .then(handleErrors)
        .then(successCallback)
        .catch(console.error);
}
